import { requestHandler } from "../Store";

export const addFriend = (token, user_id, store_id, data) => {
  return requestHandler({
    method: "POST",
    url: `users/${user_id}/store/${store_id}/friends/`,
    token,
    data,
  });
};
export const changeFriendRequestStatus = (
  token,
  user_id,
  store_id,
  friend_id,
  data
) => {
  return requestHandler({
    method: "PUT",
    url: `users/${user_id}/store/${store_id}/friends/${friend_id}/status`,
    token,
    data,
  });
};
export const deleteFriend = (token, user_id, friend_id) => {
  return requestHandler({
    method: "DELETE",
    url: `users/${user_id}/friends/${friend_id}/`,
    token,
  });
};
export const getAllFriends = (token, user_id) => {
  return requestHandler({
    method: "GET",
    url: `users/${user_id}/friends/`,
    token,
  });
};

export const getPendingFriendRequestsCount = (
  token,
  user_id,
  friend_id = user_id
) => {
  return requestHandler({
    method: "GET",
    url: `users/${user_id}/friends/${friend_id}/pendingRequestsCount`,
    token,
  });
};
